query allBetTickers {
  allBetTickerConfigurations(orderBy: CREATED_AT_ASC) {
    nodes {
      betTickerId
      betTickerName
      enabled
      filters
      inactiveFilters
      operatorId
      highlights
      createdAt
    }
  }
}
